import axios, { AxiosError } from 'axios';
import AuthService from '@/services/auth';
import { router } from '../router/';

const axiosInstance = axios.create();
const erreursNotifier: string[] = ['400'];

// Ajoute intercepteur afin d'injecter le token dans toutes les requêtes
axiosInstance.interceptors.request.use(
  (config) => {
    const token = AuthService.getAuthToken();
    if (token) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/** Default error message */

// Intercepteur des erreurs globales
axiosInstance.interceptors.response.use(undefined, (error: AxiosError) => {

  const errorCode = error.response?.status?.toString() || '500';

  // Ne pas rediriger erreurs 400 (Bad Request et Unauthorized) => Affichage sous forme de notifier
  if (erreursNotifier.includes(errorCode)) {
    return Promise.reject(error);
  }

    const currentRoute = router.currentRoute;
    const targetPath = '/erreur-generale';
    const targetQuery = { errorCode };

    // Vérifier si la route actuelle est différente de la route cible
    if (currentRoute.path !== targetPath) {
      router.push({
        path: targetPath,
        query: targetQuery
      });
    }

  return Promise.reject(error);
});

export default axiosInstance;
